import { useContext } from 'react';
import { BlockchainManagementServiceContext } from '../context/blockchain-management-service';
export const useBlockchainManagementService = () => {
    const context = useContext(BlockchainManagementServiceContext);
    if (!context) {
        throw new Error('useBlockchainManagementService must be used within a BlockchainManagementServiceProvider');
    }
    return context.blockchainManagementService;
};
//# sourceMappingURL=blockchain-management-service.js.map